import { useGameState } from '../GameProvider';
import Card from './Card';
import './ShowdownReplayModal.css';

/**
 * Read-only replay of a past round's showdown: every player's 5/5/3
 * arrangement and their round score. Fed by a roundHistory entry (see the
 * scoreRound CF). Opened from the ScoreHistory table.
 */
export default function ShowdownReplayModal({ round, onClose }) {
  const { uid } = useGameState();
  if (!round) return null;

  const entries = Object.entries(round.arrangements || {});
  // Show me first, then the rest.
  entries.sort(([a], [b]) => (a === uid ? -1 : b === uid ? 1 : 0));

  const fmt = (n) => (n > 0 ? `+${n}` : `${n ?? 0}`);
  const cls = (n) => (n > 0 ? 'srm-pos' : n < 0 ? 'srm-neg' : 'srm-zero');

  return (
    <div className="srm-overlay" onClick={onClose} data-testid="replay-modal">
      <div className="srm-modal" onClick={e => e.stopPropagation()}>
        <div className="srm-header">
          <h3>Round {round.roundNumber} — Showdown</h3>
          <button className="srm-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="srm-players">
          {entries.map(([pid, arr]) => {
            const name = round.names?.[pid] || 'Player';
            const score = round.totals?.[pid];
            return (
              <div key={pid} className={`srm-player ${pid === uid ? 'srm-player--me' : ''}`}>
                <div className="srm-player__head">
                  <span className="srm-player__name">{name}{pid === uid ? ' (you)' : ''}</span>
                  <span className={`srm-player__score ${cls(score)}`}>{fmt(score)}</span>
                </div>
                {['top', 'middle', 'bottom'].map(rowKey => (
                  <div key={rowKey} className="srm-row">
                    <span className="srm-row__label">{rowKey === 'middle' ? 'MID' : rowKey === 'bottom' ? 'BOT' : 'TOP'}</span>
                    <div className="srm-row__cards">
                      {(arr?.[rowKey] || []).map((card, i) => (
                        <Card key={card.id || i} card={card} size="small" disabled />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
